import { render, staticRenderFns } from "./haha.vue?vue&type=template&id=48cdbf7c&scoped=true&"
import script from "./haha.vue?vue&type=script&lang=js&"
export * from "./haha.vue?vue&type=script&lang=js&"
import style0 from "./haha.vue?vue&type=style&index=0&id=48cdbf7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cdbf7c",
  null
  
)

export default component.exports